// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Button.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Button.tsx");
  import.meta.hot.lastModified = "1732036225877.6416";
}
// REMIX HMR END

import { Link } from "@remix-run/react";
import clsx from "clsx";
const variants = {
  primary: clsx("bg-primary-800 text-white", "hover:bg-primary-600 transition-[background] duration-200 ease-in-out", "focus-visible:bg-primary-800 focus-visible:ring-primary-300"),
  secondary: clsx("bg-neutral-50 text-neutral-500 border border-primary-300", "hover:text-neutral-600 hover:border-gradient-secondary hover:transition-border hover:duration-200 hover:ease-in-out", "focus-visible:bg-neutral-100 focus-visible:ring-neutral-400"),
  tertiary: clsx("bg-gradient-secondary bg-[length:400%_400%] text-white border border-secondary-300", "hover:bg-[length:100%_100%] duration-300 transition-[background-size] hover-button", "focus-visible:bg-secondary-500 focus-visible:ring-secondary-800"),
  quaternary: clsx("bg-transparent text-neutral-100 border border-secondary-500", "hover:text-neutral-100 hover:border-neutral-100 hover:transition-border hover:duration-300 hover:ease-out", "focus-visible:border-primary-200 focus-visible:ring-neutral-400 focus-visible:border-[3px] focus-visible:outline"),
  disabled: "bg-neutral-200 text-neutral-400 cursor-not-allowed"
};
const sizeClasses = {
  base: "px-5 py-3 rounded-3xl",
  sm: "px-3 py-2 rounded-3xl",
  xl: "px-6 py-4.5 rounded-[40px] text-lg"
};
export default function Button({
  children,
  variant,
  size = "base",
  className,
  disabled,
  ...props
}) {
  const variantClass = disabled ? variants.disabled : variants[variant];
  const sizeClass = size ? sizeClasses[size] : sizeClasses.base;
  if ("to" in props) {
    return <Link className={clsx("font-medium", "focus:outline-none focus-visible:ring-2", variantClass, sizeClass, className)} {...props}>
        {children}
      </Link>;
  }
  return <button className={clsx("font-medium", "focus:outline-none focus-visible:ring-2", variantClass, sizeClass, className)} disabled={disabled} {...props}>
      {children}
    </button>;
}
_c = Button;
var _c;
$RefreshReg$(_c, "Button");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;